<template>
  <nav
    id="nav"
    class="DesktopNav"
    :class="{ '-logoLeft': logoLeft }"
    @click="scrollToTop()"
  >
    <div class="inner-nav">
      <div class="item sitename">
        <router-link
          v-if="!hideSitename"
          class="site-name"
          :to="{ name: 'root' }"
          active-class="home"
        >
          {{ sitename }}
        </router-link>
        <div
          class="nav-icon"
          v-if="streamingEnabled"
          :title="streamingTooltip"
        >
          <FAIcon
            v-if="streamingConnected"
            fixed-width
            class="fa-scale-110 fa-old-padding"
            icon="plug"
          />
          <FAIcon
            v-else
            fixed-width
            class="fa-scale-110 fa-old-padding"
            icon="plug-circle-xmark"
          />
        </div>
      </div>
      <router-link
        class="logo"
        :to="{ name: 'root' }"
        :style="logoBgStyle"
        :title="sitename"
      >
        <div
          class="mask"
          :style="logoMaskStyle"
        />
        <img
          :src="logo"
          :style="logoStyle"
        >
      </router-link>
      <div class="item right actions">
        <SearchBar
          v-if="currentUser || !privateMode"
          @toggled="onSearchBarToggled"
          @click.stop
        />
        <AccountMenu
          v-if="searchBarHidden"
          class="nav-icon"
          @click.stop
        />
      </div>
    </div>
  </nav>
</template>
<script src="./desktop_nav.js"></script>

<style src="./desktop_nav.scss" lang="scss"></style>
